import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { Col, Form, Modal, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "helpers/api";
import { useEffect, useState } from "react";
interface AddLeadModalProps {
  show: boolean;
  handleClose: () => void;
  setCollaborators: any;
  collaborators: any;
  selectedLeadId: any;
}

type Inputs = {
  collaborator_first_name: string;
  collaborator_last_name: string;
  collaborator_phone: string;
  collaborator_email: string;
  collaborator_status: string;
};

const EditCollaboratorModal = ({
  show,
  handleClose,
  setCollaborators,
  selectedLeadId,
  collaborators,
}: AddLeadModalProps) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();
  const [loading, setLoading] = useState(false);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    setLoading(true);
    try {
      const response = await axiosInstance.patch(
        `/collaborators/${selectedLeadId}`,
        {
          collaborator_first_name: data.collaborator_first_name,
          collaborator_last_name: data.collaborator_last_name,
          collaborator_phone: data.collaborator_phone,
          // collaborator_email: data.collaborator_email,
        }
      );

      toast.success(response.data.message);
      setCollaborators(response.data.data.collaborators);
      reset();
      handleClose();
      setLoading(false);
    } catch (error: any) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    const filterData = collaborators.find(
      (item: any) => item.collaborator_id === selectedLeadId
    );

    setValue(
      "collaborator_first_name",
      filterData.invitee.collaborator_first_name
    );
    setValue(
      "collaborator_last_name",
      filterData.invitee.collaborator_last_name
    );
    setValue("collaborator_email", filterData.invitee.collaborator_email);
    setValue("collaborator_status", filterData.invitee.collaborator_status);
    setValue("collaborator_phone", filterData.invitee.collaborator_phone);
  }, [selectedLeadId]);

  return (
    <Modal
      size="lg"
      show={show}
      centered
      backdrop="static"
      onHide={handleClose}
      contentClassName="bg-body-highlight p-6 border border-translucent"
    >
      <Modal.Header className="border-0 p-0 mb-2">
        <h3 className="mb-0">Update Collaborator</h3>
        <Button
          variant="phoenix-secondary"
          className="ms-auto"
          onClick={handleClose}
          size="sm"
        >
          <FontAwesomeIcon icon={faTimes} className="text-danger" />
        </Button>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="px-0 mb-6">
          <Row className="g-3">
            <Col lg={6}>
              <Form.Group>
                <Form.Label>
                  First Name<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  {...register("collaborator_first_name", {
                    required: true,
                    maxLength: 100,
                  })}
                />
              </Form.Group>
              {errors.collaborator_first_name?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  First name is required
                </p>
              )}
            </Col>
            <Col lg={6} className="">
              <Form.Group>
                <Form.Label>
                  Last Name<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  {...register("collaborator_last_name", {
                    required: true,
                    maxLength: 100,
                  })}
                />
              </Form.Group>
              {errors.collaborator_last_name?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  Last Name is Required
                </p>
              )}
            </Col>
            <Col lg={6}>
              <Form.Group>
                <Form.Label>
                  Email<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  placeholder="Email"
                  {...register("collaborator_email", {
                    required: true,
                    maxLength: 80,
                  })}
                />
              </Form.Group>
              {errors.collaborator_email?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  Email is required
                </p>
              )}
            </Col>
            <Col lg={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  inputMode="tel"
                  placeholder="Phone"
                  {...register("collaborator_phone", {
                    maxLength: 80,
                  })}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0 p-0">
          <Button
            variant="link"
            className="text-danger px-3 my-0"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            className="my-0"
            loading={loading}
          >
            Update
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditCollaboratorModal;
